export default __webpack_public_path__ + "static/media/00.2cb3941f.jpg";